import React from 'react';
import { getStatusDisplay } from '../configs/statusFlowRules';

const StatusBadge = ({ 
  entityType, 
  status, 
  itemType = null,
  className = "",
  size = "sm" // sm, md, lg
}) => {
  const statusConfig = getStatusDisplay(entityType, status);
  
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-base';
      case 'md':
      default:
        return 'px-3 py-1 text-sm';
    }
  };

  const baseClasses = `inline-flex items-center rounded-full font-medium border ${getSizeClasses()}`;
  const statusClasses = `${statusConfig.bg} ${statusConfig.text} ${statusConfig.border}`;

  return (
    <span 
      className={`${baseClasses} ${statusClasses} ${className}`}
      title={`Status: ${statusConfig.label} (${statusConfig.category})`}
    >
      {statusConfig.label}
    </span>
  );
};

// Specialized status badges for different contexts
export const OrderItemStatusBadge = ({ orderItem, className = "", size = "sm" }) => {
  return (
    <StatusBadge
      entityType="orderItem"
      status={orderItem.status}
      itemType={orderItem.type}
      className={className}
      size={size}
    />
  );
};

export const FulfillmentGroupStatusBadge = ({ fulfillmentGroup, className = "", size = "sm" }) => {
  return (
    <StatusBadge
      entityType="fulfillmentGroup"
      status={fulfillmentGroup.status}
      className={className}
      size={size}
    />
  );
};

export const OrderStatusBadge = ({ order, className = "", size = "lg" }) => {
  return (
    <StatusBadge
      entityType="order"
      status={order.status}
      className={className}
      size={size}
    />
  );
};

export const RequestStatusBadge = ({ request, className = "", size = "sm" }) => {
  return (
    <StatusBadge
      entityType="request"
      status={request.status}
      className={className}
      size={size}
    />
  );
};

export default StatusBadge; 